"use client"

import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react"

interface CommandKContextType {
  open: boolean
  appear: boolean
  show: () => void
  close: () => void
}

const initialCommandKContext: CommandKContextType = {
  open: false,
  appear: false,
  show: () => {},
  close: () => {},
}

const CommandKContext = createContext<CommandKContextType>(
  initialCommandKContext
)

export const useCommandK = () => useContext(CommandKContext)

export const CommandKProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [open, setOpen] = useState(false)
  const [appear, setAppear] = useState(false)

  const show = useCallback(() => {
    setOpen(true)
    setTimeout(() => setAppear(true), 0)
  }, [])

  const close = useCallback(() => {
    setAppear(false)
    setTimeout(() => setOpen(false), 300)
  }, [])

  const commandKContextValue = useMemo(
    () => ({ open, appear, show, close }),
    [open, appear, show, close]
  )

  return (
    <CommandKContext.Provider value={commandKContextValue}>
      {children}
    </CommandKContext.Provider>
  )
}
